import React, { useEffect } from "react";
import { Table, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useKeyWordsModel } from "../keyWordsModel";
import { IKerwordsTypeDetails } from "../keyWordsService";
import { YhBut } from "@/components/YhButton";


//关键词分类管理
export function DataTable() {
    const {
        dataSourceType,
        loadDataType, setSelectedRowKeysType, removeKeyWordsType, setKeyWordsTypeDrawer, updataKeyWordsType
    } = useKeyWordsModel();

    const columns: ColumnsType<IKerwordsTypeDetails> = [
        {
            title: "序号",
            width: 100,
            align: "center",
            render: (text, record, index) => index + 1
        },
        {
            title: '分类名称',
            align: "center",
            dataIndex: 'name',
        },
        {
            title: '状态',
            align: "center",
            dataIndex: 'status',
            className: "td-wrap",
            render: (text, record) => (
                <Switch
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    checked={+record.status ? true : false}
                    onChange={(checked: boolean, e: MouseEvent) => {
                        let { id, name } = record;
                        e.stopPropagation();
                        updataKeyWordsType({ id, name, status: checked ? 1 : 0 }, checked ? "启用成功" : "禁用成功");
                    }}
                />
            ),
        },
        {
            title: '操作',
            width: 200,
            align: "center",
            className: "td-wrap",
            render: (txt, record) => <>
                <YhBut
                    type="edit"
                    txt="编辑"
                    click={() => {
                        setSelectedRowKeysType([record]);
                        setKeyWordsTypeDrawer({ visible: true, mode: "edit" })
                    }}
                />
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeKeyWordsType(record.id)}
                />
            </>
        }
    ];

    useEffect(() => {
        loadDataType();
    }, [])

    return (
        <Table
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataSourceType}
            pagination={false}
            // pagination={{
            //     ...pgCfgType,
            //     position: ["bottomCenter"],
            //     showTotal: () => `共${pgCfgType.total}条`,
            //     onChange: (pageNum, pageSize) => {
            //         loadDataType({ pageNum, pageSize })
            //     }
            // }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
